import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import SpinningLogo from '../../components/Spinner';
import CustomPageHeader from '../../components/CustomPageHeader';
import { downloadExcel } from '../../utils/DownloadXls';
import CommonLeadsTable from './CommonLeadsTable';
import CustomOffCanvas from '../../components/CustomOffCanvas';
import AddCommonLead from './AddCommonLead';
import AddEmotionLead from './AddEmotionLead';
import Table from '../../components/Table';
import BtnSpinner from '../../components/BtnSpinner';
import { Trash } from 'lucide-react';
import Pagination from '../../components/Pagination';
import moment from 'moment';

function HealthBengali() {

    const [isOffCanvasOpen, setIsOffCanvasOpen] = useState({ state: false, name: "" });
    const [leads, setLeads] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState({ state: false, name: "" });
    const [currentPage, setCurrentPage] = useState(1);
    const [refresh, setRefresh] = useState(false);
    const [currentLead, setCurrentLead] = useState(null);
    const [deleteId, setdeleteId] = useState(null)

    const token = localStorage.getItem("token");

    const totalItems = leads?.length; // Total number of items
    const itemsPerPage = 20;

    const currentData = leads?.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const navigate = useNavigate();

    const handleRefresh = () => setRefresh(!refresh);

    const handleSearch = async () => {
        if (!searchTerm) {
            return ErrorTost("Enter a key to serach")
        }

        if (currentPage !== 1) {
            setCurrentPage(1)
        }

        await getLeads(searchTerm)
    };

    const getLeads = async () => {
        setLoading({ state: true, name: "fetchleads" });
        try {
            const res = await Apirequests(
                `leads/get-leads-new?q=${searchTerm}`,
                "GET",
                {},
                {
                    Authorization: `Bearer ${token}`,
                    lead_type: "healthlead"
                }
            );
            //   console.log(res,'course get res')
            if (res?.success) {
                setLeads(res.data);
            }
        } catch (error) {
            console.log(error, "leads res error.");
        }
        setLoading({ state: false, name: "" });
    };

    const deleteLead = async (id) => {
        setdeleteId(id);
        setLoading({ state: true, name: 'deletelead' })
        try {
            const deleteRes = await Apirequests(
                `leads/delete-lead/${id}`,
                "DELETE",
                { lead_type: "healthlead" },
                {
                    Authorization: `Bearer ${token}`,
                }
            );
            // console.log(deleteRes,'delete lead');
            setRefresh(!refresh);
            if (deleteRes?.success) {
                SuccessTost(deleteRes?.message);
            } else {
                ErrorTost(deleteRes?.message);
            }
        } catch (error) {
            console.log(error, "delete course error");
            ErrorTost("Something went wrong, please try again later.")
        }
        setdeleteId(null);
        setLoading({ state: false, name: "" })
    };


    useEffect(() => {
        getLeads();
    }, [refresh, token]);


    if (loading.state && loading.name === "fetchleads") {
        return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
            <SpinningLogo />
        </div>
    }

    return (
        <div>
            <CustomPageHeader
                title={"Health Bengali(Paid) Leads"}
                text={searchTerm}
                setText={setSearchTerm}
                handleSearch={handleSearch}
                onClick={() => setIsOffCanvasOpen({ state: true, name: "addhealthlead" })}
                btnText={"Add Lead"}
                handleBackClick={() => navigate("/")}
                handleRefresh={handleRefresh}
                handleDownload={() => downloadExcel(leads, 'emotionleads')}
            />

            <main className="mx-auto py-6 sm:px-6 lg:px-8">
                <div className="px-4 py-6 sm:px-0">
                    <div className="overflow-x-auto">
                        <Table
                            tableHead={

                                <tr>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Whatsapp Number</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Timeslot</th>
                                    {/* <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th> */}
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Crated At</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                </tr>
                            }
                            tableBody={
                                currentData?.map((lead, i) =>
                                    <tr key={i}>
                                        {/* <td className="px-6 py-4 whitespace-nowrap"><span className='text-indigo-600 cursor-pointer' onClick={() => { setIsOffCanvasOpen({ state: true, name: 'vieworderdetails' }); setCurrentOrder(order) }}>{order?.order_id || "not available"}</span></td> */}
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.name}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.email}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.phone}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.timeslot}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{moment(lead?.createdAt).format('DD-MM-YY hh:mm a')}</td>
                                        <td className="px-6 py-4 whitespace-nowrap flex gap-3">
                                            <button className='flex bg-red-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => deleteLead(lead?._id)}>
                                                {
                                                    loading.state && loading.name === "deletelead" && deleteId === lead?._id ?
                                                        <BtnSpinner /> :
                                                        <>
                                                            <Trash className='text-red-700 text-sm' size={20} />
                                                            <span className='text-red-700 text-sm'>Delete</span>
                                                        </>
                                                }

                                            </button>

                                            {/* <button className='flex bg-gray-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => { setIsOffCanvasOpen({ state: true, name: "editorder" }); setCurrentOrder(order) }}><Edit3 size={18} /> Edit</button> */}
                                        </td>
                                    </tr>)
                            }
                        />
                    </div>
                </div>
                {leads?.length ?
                    <div className="flex gap-x-2 items-center justify-between">
                        <p>total: {leads?.length}</p>
                        <Pagination
                            page={currentPage}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            onPageChange={handlePageChange}
                        />
                    </div> : null}
            </main>

            <CustomOffCanvas
                open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "addhealthlead"}
                close={() => setIsOffCanvasOpen({ state: false, name: "" })}
                content={
                    <AddEmotionLead
                        close={() => setIsOffCanvasOpen({ state: false, name: "" })}
                        setRefresh={setRefresh}
                        title={"Add Health Bengali(Paid) Lead"}
                        leadUrl={"leads/submit-healthpage-lead"}
                    />
                }
            />
        </div>
    )
}

export default HealthBengali